import AmioHttpService from '@/services/amio/amio-http.service'

// Super-admin Qdrant collection registry (PRO-184). All endpoints are gated by verifyAdmin on the
// engine; the page is only reachable for is-admin users.
class VectorCollectionService extends AmioHttpService {
  async list() {
    try {
      const response = await this.requestGet('/vector-collections')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  // BE-driven editable index schema types + the SSOT-locked vector geometry (size/distance)
  async getIndexSchema() {
    try {
      const response = await this.requestGet('/vector-collections/index-schema')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async create(payload) {
    try {
      const response = await this.requestPost('/vector-collections', payload)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async update(id, patch) {
    try {
      const response = await this.requestPatch(`/vector-collections/${id}`, patch)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async delete(id) {
    try {
      await this.requestDelete(`/vector-collections/${id}`)
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

export default new VectorCollectionService()
